(function () {
  const initStaticPageSidebar = () => {
    document.querySelectorAll('[data-static-page-sidebar]').forEach((root) => {
      if (root.dataset.staticPageSidebarInitialized === 'true') {
        return;
      }

      const toggle = root.querySelector('[data-static-page-sidebar-toggle]');
      const body = root.querySelector('[data-static-page-sidebar-body]');
      const desktopQuery = window.matchMedia('(min-width: 1200px)');

      if (!toggle || !body) {
        return;
      }

      const setExpanded = (isExpanded) => {
        root.classList.toggle('is-open', isExpanded);
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        body.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
      };

      const syncLayout = () => {
        if (desktopQuery.matches) {
          setExpanded(true);
          body.removeAttribute('aria-hidden');
          return;
        }

        setExpanded(root.classList.contains('is-open'));
      };

      toggle.addEventListener('click', () => {
        if (desktopQuery.matches) {
          return;
        }

        setExpanded(!root.classList.contains('is-open'));
      });

      desktopQuery.addEventListener('change', syncLayout);

      if (desktopQuery.matches) {
        syncLayout();
      } else {
        setExpanded(true);
      }

      root.dataset.staticPageSidebarInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStaticPageSidebar);
  } else {
    initStaticPageSidebar();
  }

  document.addEventListener('shopify:section:load', initStaticPageSidebar);
})();
